<div class="container-fluid fullsize">
	<bp-navbar></bp-navbar>
	<div class="main-frame">
		<router-outlet></router-outlet>
	</div>
</div>
